export const environment = {
  production: true,
  apiUrl: 'https://portal.scheidfamilywines.com/',
  apiRequestBody: '{"email": "{0}","user_id": "", "AllUser": 0,	"system": "{1}", "profileId": "{2}" }',
  apiRequestBody_children: '{"email": "{0}","user_id": "", "AllUser": 0,	"system": "{1}", "no": "{2}"}',
  apiUser:'eng.m.eldeaghedy@gmail.com',
  apiPassword:'123@qwe',
  esriTokenUrl: 'https://vitmap.scheidvineyards.com:6443/arcgis/tokens/generateToken',
  esriUser:'arcgis',
  esriPassword:'vit1Map',
  esriClient:'http://portal.scheidfamilywines.com',
  fileFolderPath: 'C:\\inetpub\\wwwroot\\portal.scheidfamilywines.com\\files',
  httpPath: 'https://portal.scheidfamilywines.com/files/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts